import sectionFaqGrid06Css from '../css-snippets/section-faq-grid-06';

const html = `
<style>${sectionFaqGrid06Css}</style>
<div
  data-container="faq-grid-container-fluid-unique-id"
  data-id="unique-id"
  data-attribute="faq-grid-container-fluid"
  data-top-padding="true"
  data-bottom-padding="true"
  class="faq-grid-container-fluid"
  data-container-full-width="false"
>
  <div data-attribute="faq-grid-container" class="faq-grid-container container">
    <div data-attribute="title-faq-grid" class="title-faq-grid">
      <h2 style="text-align: center;">
        <strong>Frequently Asked Questions</strong>
      </h2>
    </div>
    <div data-attribute="list-item" class="list-item">
      <div data-attribute="item-wapper" class="item-wapper">
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            How often should I use the Collagen Night Wrapping Mask?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            For best results, use 2-3 times a week before bed to maintain smooth, radiant skin.
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper">
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            Will this mask help with dark spots and uneven skin tone?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Absolutely! This mask is specifically designed to reduce dark spots and promote a more even complexion.
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper">
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            Is it suitable for sensitive skin?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Yes, our formula is gentle yet effective, making it safe for most skin types, including sensitive skin.
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper">
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            How long does it take to see results?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Many customers report seeing visible improvements in skin brightness, tone, and hydration after just one use.
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper">
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            Does this mask help with pores and blackheads?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Yes, it works to minimize pores and remove blackheads, leaving your skin smoother and clearer.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
